import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Auth from "../Auth";

class Logout extends Component {
  constructor(props) {
    super(props);
    Auth.logout();
  }
  render() {
    return <Redirect to="/login" />;
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/components/Logout.js